import i18n from 'i18n';
export const TRANSLATION = i18n.t.bind(i18n);
